import React from 'react';
import { styleIcon } from '../style_icon.js';
export function SortUpIcon({ title = 'Sort Up Icon', ...rest }) {
    const style = styleIcon(rest);
    return (React.createElement("svg", { ...style, viewBox: "0 0 8 14" },
        !style['aria-hidden'] && React.createElement("title", null, title),
        React.createElement("path", { d: "M4.49989 14H3.49989C3.22375 14 2.99989 13.7761 2.99989 13.5V4H0.542978C0.069638 4 -0.138712 3.40336 0.231718 3.1087L3.68863 0.35892C3.87083 0.21399 4.12895 0.21399 4.31115 0.35892L7.76806 3.1087C8.1385 3.40336 7.93014 4 7.4568 4H4.99989V13.5C4.99989 13.7761 4.77603 14 4.49989 14Z" })));
}
//# sourceMappingURL=sort_up_icon.js.map